import React, { useState } from 'react';
import { useOutletContext } from "react-router-dom";

function CreatePostForm({ onClose, onPostCreated }) {
  const [postContent, setPostContent] = useState('');
  const [uploadedImage, setUploadedImage] = useState(null);
  const [uploadedVideo, setUploadedVideo] = useState(null);
  const { userId, pageId } = useOutletContext(); // Access userId and pageId from context
  const [imageFileDetails, setImageFileDetails] = useState(null);
  const [uploadError, setUploadError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Access the API URL from environment variables
  const API_URL = process.env.REACT_APP_API_URL || 'https://pyate-backend-production-9749.up.railway.app';

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setUploadedImage(reader.result);
      };
      reader.readAsDataURL(file);
      setImageFileDetails({
        name: file.name,
        type: file.type,
      });
    }
  };

  const handleVideoUpload = async (e) => {
    const file = e.target.files[0];
    if (file) {
      setUploadedVideo(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setUploadError('');
    setIsSubmitting(true);

    const formData = new FormData();
    formData.append('page_id', pageId);
    formData.append('user_id', userId);
    formData.append('post_content', postContent);

    if (uploadedImage) {
      try {
        const blob = await (await fetch(uploadedImage)).blob();
        const filename = imageFileDetails.name;
        const filetype = imageFileDetails.type;
        const imageFile = new File([blob], filename, { type: filetype });
        formData.append('image', imageFile);
      } catch (error) {
        console.log("error", error);
      }
    }

    if (uploadedVideo) {
      formData.append('video', uploadedVideo);
    }

    console.log('Form Data:', ...formData);

    try {
      const response = await fetch(`${API_URL}/page/post/create_post`, {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        const data = await response.json();
        console.log('Post created:', data);
        onPostCreated(data);
        onClose();
      } else {
        const errorData = await response.json();
        console.error('Error creating post:', response.status, response.statusText, errorData);
        setUploadError(errorData.error || `Error creating post: ${response.statusText}`);
      }
    } catch (error) {
      console.error('Error:', error);
      setUploadError('Network error occurred. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="create-post-modal-edit">
      <div className="create-post-content-edit">
        <div className="container-edit">
          <h3>Create a Post</h3>
          {uploadError && <div className="error-message">{uploadError}</div>}
          <form onSubmit={handleSubmit}>
            <textarea
              className="post-input-edit"
              placeholder={postContent ? "" : "What's on your mind?"}
              value={postContent}
              onChange={(e) => setPostContent(e.target.value)}
            />

            <h4>Upload Image</h4>
            <input type="file" accept="image/*" name="image" onChange={handleImageUpload} />
            {uploadedImage && <img src={uploadedImage} alt="Preview" className="preview-image" />}

            <h4>Upload Video</h4>
            <input type="file" accept="video/*" onChange={handleVideoUpload} />
            {uploadedVideo && (
              <video controls className="preview-video">
                <source src={URL.createObjectURL(uploadedVideo)} type={uploadedVideo.type} />
                Your browser does not support the video tag.
              </video>
            )}

            <div className="post-actions-edit">
              <button className="submit-btn-edit" type="submit" disabled={isSubmitting}>
                {isSubmitting ? "Posting..." : "Post"}
              </button>
              <button className="close-btn-edit" type="button" onClick={onClose}>Cancel</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default CreatePostForm;